// ============================================================================
// FLYOUT PANEL
// ARQUIVO: src/components/common/FlyoutPanel.jsx
// RESPONSABILIDADE: Casca genérica do painel lateral direito ("flyout"),
//   extraída de ClientAcervoTab.jsx e GlobalActivityFeed.jsx (MC38, Fase F2
//   da fusão Processos/Caderno) - as duas telas reimplementavam a mesma
//   coisa de formas ja divergentes entre si (uma sem hook compartilhado,
//   sem animacao de entrada/saida). Base escolhida: a versao animada de
//   GlobalActivityFeed.jsx (translate-x + opacity), que é estritamente
//   melhor que o unmount abrupto de ClientAcervoTab.jsx.
// Não decide O QUE mostrar dentro (children/footer) nem gerencia estado de
// seleção - isso é responsabilidade de quem usa (useClientFlyout.js e
// equivalentes). Mantém o item selecionado visível durante a animação de
// saída é responsabilidade do chamador (não zerar o estado no fechamento).
// ============================================================================
import React, { useEffect } from 'react';

export const FlyoutPanel = ({
  open,
  onClose,
  eyebrow,
  title,
  subtitle,
  footer,
  children,
  widthClassName = 'max-w-lg',
  zIndexClassName = 'z-50',
}) => {
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onClose?.();
      }
    };
    window.addEventListener('keydown', onKeyDown, true);
    return () => window.removeEventListener('keydown', onKeyDown, true);
  }, [open, onClose]);

  return (
    <div className={`fixed inset-0 ${zIndexClassName} ${open ? '' : 'pointer-events-none'}`}>
      <div
        className={`absolute inset-0 bg-black/20 transition-opacity ${open ? 'opacity-100' : 'opacity-0'}`}
        onClick={onClose}
      />
      <div
        className={`fixed inset-y-0 right-0 w-full ${widthClassName} bg-white shadow-2xl transform transition-transform ${open ? 'translate-x-0' : 'translate-x-full'}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="h-full flex flex-col">
          <div className="px-4 py-4 border-b border-slate-200 bg-slate-50">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                {eyebrow ? (
                  <div className="text-xs font-extrabold uppercase tracking-widest text-slate-500">{eyebrow}</div>
                ) : null}
                <div
                  className="mt-1 text-sm font-extrabold text-[#20243B] truncate"
                  title={typeof title === 'string' ? title : undefined}
                >
                  {title}
                </div>
                {subtitle ? <div className="mt-1 text-[11px] text-slate-500 truncate">{subtitle}</div> : null}
              </div>
              <button
                type="button"
                onClick={onClose}
                aria-label="Fechar"
                title="Fechar"
                className="px-3 py-2 rounded-lg text-xs font-extrabold uppercase tracking-widest border border-slate-200 bg-white text-slate-700 hover:bg-slate-50 shrink-0"
              >
                Fechar
              </button>
            </div>
          </div>

          <div className="flex-1 overflow-y-auto p-4 space-y-4">
            {children}
          </div>

          {footer ? (
            <div className="border-t border-slate-200 bg-white p-4">
              {footer}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default FlyoutPanel;
